import React from 'react';
import PropTypes from 'prop-types';

import {Panel, PanelHeader, Title, Div, Text} from '@vkontakte/vkui';
import {Icon as SignIcon} from '../components/icon/icon.js';
import styles from './Home.module.css';

const Sign = ({sign, go, setSign}) => (
  <Div
    className={styles.home__button}
    data-to="sign"
    onClick={(event) => {
      setSign(sign);
      go(event);
    }}
  >
    <span className={styles.home__icon} style={{background: sign.color}}>
      <SignIcon name={sign.icon} />
    </span>
    <div className={styles.home__texts}>
      <Title className={styles.home__buttonTitle} level="2">
        {sign.title}
      </Title>
      <Text className={styles.home__buttonDate}>{sign.date}</Text>
    </div>
  </Div>
);

Sign.propTypes = {
  sign: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }),
  go: PropTypes.func,
  setSign: PropTypes.func,
};

const Home = ({id, go, signs, setSign, user, hasPopout}) => {
  return (
    <Panel className={styles.home} id={id} sizeX="compact">
      {hasPopout ? null : (
        <>
          <PanelHeader>Гороскоп</PanelHeader>
          <Div>
            {user?.bdate ? null : (
              <Sign
                go={go}
                sign={{
                  title: 'Указать дату рождения',
                  date: 'Для более точных прогнозов',
                  icon: 'help',
                  color: 'linear-gradient(135deg, #250A4D 0%, #21083F 100%)',
                  decorator_id: 6100,
                }}
              />
            )}
            {signs.map((sign) => (
              <Sign go={go} key={sign.date} setSign={setSign} sign={sign} />
            ))}
          </Div>
        </>
      )}
    </Panel>
  );
};

Home.propTypes = {
  id: PropTypes.string.isRequired,
  go: PropTypes.func.isRequired,
  setSign: PropTypes.func.isRequired,
  signs: PropTypes.array,
  user: PropTypes.shape({
    id: PropTypes.number,
    bdate: PropTypes.string,
    photo_200: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    city: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
};

export default Home;
